/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie200,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie401,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie404,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPiePathParams,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPieQueryResponse,
} from "../../types/classPlanningFeedbacksController/GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie.ts";
import { feedbackChartDataViewModelSchema } from "../feedbackChartDataViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPiePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPiePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie200Schema =
  z.lazy(
    () => feedbackChartDataViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie404>;

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPieQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPie200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsPieQueryResponse>;
